import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import ApiRequest from "../../../helper/ApiRequest";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import TmsIntegrationForm from "./TmsIntegrationForm";

const addIntegrationEndpoint = ApiEndpoints.tmsIntegration.integrationCreate;

export default function AddTmsIntegration() {
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    try {
      const response = await ApiRequest("POST", addIntegrationEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      response.error ? toast.error(response.message) : toast.success(response.message);
      if (!response.error) navigate("/tms-integration");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: "TMS Integration",
    user: "Admin",
    innerpage: "TMS Integration / Add Integration"
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <TmsIntegrationForm formId="tmsIntegrationAdd" onSubmit={handleSubmit} />
        <button type="submit" form="tmsIntegrationAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
